import React, { useState, useEffect, useRef } from "react";
import {
  IntegrationCard,
  AuthorizedTitle,
  SubText,
  AuthorizeButton,
} from "./style";
import Check from "../../assets/Check.svg";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import DeleteIcon from "../../assets/delete-grey.svg";
import { useTranslation } from "react-i18next";

const Microsoft = ({ integration, index, user, provider, isMicrosoftConnected, refresh }) => {
  const { t } = useTranslation();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isHide, setIsHide] = useState(false);
  // Use useRef to persist the window reference across renders
  const microsoftAuthWindow = useRef(null);

  // Read user credentials from localStorage (written at login time)
  const userToken = localStorage.getItem("user_token");
  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    if (!provider || !provider.length) {
      setIsLoading(false);
      setIsAuthorized(false);
      setIsHide(false);
      return;
    }

    const isMicrosoftAuth = provider.some(
      (p) => p.email_provider === "oAuthMicrosoft" && p.feature_type === "integration"
    );
    
    setIsLoading(false);
    setIsAuthorized(isMicrosoftAuth);
    setIsHide(isMicrosoftAuth);
  }, [provider, isMicrosoftConnected]);

  const handleMicrosoftAuth = async () => {
    try {
      setIsLoading(true);

      // Open the auth URL in a new tab
      microsoftAuthWindow.current = window.open(
        "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=33e2d6a4-3f27-44c5-9061-ddca9c7d7d77&response_type=code&scope=openid%20IMAP.AccessAsUser.All%20offline_access%20SMTP.Send%20User.Read%20email%20Mail.Send",
        "_blank",
        "width=600,height=600",
      );
    } catch (error) {
      console.error("Error connecting with Microsoft:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data.type === "MICROSOFT_OAUTH_CALLBACK") {
        const { accessToken, refreshToken, userDetails } = event.data;
        if (accessToken && refreshToken && userDetails) {
          console.log("accessToken:", accessToken);
          console.log("refreshToken:", refreshToken);
          console.log("userDetails:", userDetails);
          await createMicrosoft(accessToken, refreshToken, userDetails);
          if (
            microsoftAuthWindow.current &&
            !microsoftAuthWindow.current.closed
          ) {
            microsoftAuthWindow.current.close();
          }
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const createMicrosoft = async (accessToken, refreshToken, userDetails) => {
    const requestBody = {
      email_provider: "oAuthMicrosoft",
      userId: userId,
      name: userDetails.name,
      email: userDetails.email,
      password: accessToken,
      imap_hostname: refreshToken,
      feature_type: "integration"
    };
    try {
      const res = await axios.post(
        `https://api.emailflowpro.aivoria.nl/api/provider/createGmail`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        },
      );
      console.log("Create Microsoft Response", res.data);
      if (res.data.emailProvider?.email_provider === "oAuthMicrosoft") {
        toast.success("Microsoft connected successfully!");
        await refresh(); // Wait for refresh to complete
        setIsAuthorized(true);
        setIsHide(true);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Create Microsoft Error", error);
      toast.error("Failed to connect Microsoft");
      setIsAuthorized(false);
      setIsHide(false);
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    // Find the specific Microsoft provider entry, not just provider[0]
    const microsoftProvider = provider.find((p) => p.email_provider === "oAuthMicrosoft");
    if (!microsoftProvider) return;
    try {
      setIsLoading(true);
      const res = await axios.delete(
        `https://api.emailflowpro.aivoria.nl/api/provider/delete/${microsoftProvider.id}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        },
      );
      console.log("Delete Microsoft Response", res.data);
      toast.success(res.message);
      refresh();
      setIsAuthorized(false);
    } catch (error) {
      console.log("Delete Microsoft Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <IntegrationCard
        key={index}
        style={{
          background: isHide ? "beige" : "#f4f6f6",
          opacity: isHide ? "0.5" : "1",
        }}
      >
        <AuthorizedTitle>
          <span
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <span>
              <img src={integration.icon} alt="icon" />
            </span>
            {integration.name}
          </span>
          {/* {isAuthorized && <img src={Check} alt="check" />} */}
          {isAuthorized && (
            <img
              src={DeleteIcon}
              alt="delete"
              onClick={() => !isLoading && handleDelete()}
              style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
            />
          )}
        </AuthorizedTitle>
        <SubText>{integration.description}</SubText>
        <AuthorizeButton
          onClick={() => {
            handleMicrosoftAuth();
            setIsLoading(true);
          }}
          disabled={isLoading || isAuthorized || isHide}
          isAuthorized={isAuthorized}
        >
          {isLoading ? (
            <CircularProgress size={13} color="inherit" />
          ) : isAuthorized ? (
            t("integrations.authorized")
          ) : (
            t("integrations.authorize")
          )}
        </AuthorizeButton>
      </IntegrationCard>
    </>
  );
};

export default Microsoft;
